import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const createSawSpecs = async (
	sawSpecs: Record<string, unknown> & { ProductId: number },
) => {
	const apiService = new MESApiService();
	const val = (key: string) =>
		(sawSpecs[key] as string | number | null) ?? null;
	const parameters: spParameter[] = [
		{ name: "ProductId", value: sawSpecs.ProductId },
		{ name: "TargetLength", value: val("TargetLength") },
		{ name: "TopTolerance", value: val("TopTolerance") },
		{ name: "BottomTolerance", value: val("BottomTolerance") },
		{ name: "FinishPcB", value: val("FinishPcB") },
		{ name: "MillLength", value: val("MillLength") },
		{ name: "MillPcB", value: val("MillPcB") },
	];
	return await apiService.callV2("[FAB].[UpsertSawSpecs]", parameters);
};

export const updateSawSpecs = async (
	productId: number,
	fields: Record<string, string | number | boolean | null>,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "ProductId", value: productId }];

	for (const [field, value] of Object.entries(fields)) {
		parameters.push({ name: field, value: value });
	}

	return await apiService.callV2("[FAB].[UpsertSawSpecs]", parameters);
};

export const deleteSawSpecs = async (productId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "ProductId", value: productId }];
	return await apiService.callV2("[FAB].[DeleteSawSpecs]", parameters);
};
